import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=04f660b1&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"
import style0 from "./Text.vue?vue&type=style&index=0&id=04f660b1&prod&lang=scss&scoped=true"
import style1 from "./Text.vue?vue&type=style&index=1&id=04f660b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f660b1",
  null
  
)

export default component.exports